import { Global } from '../../global';
import { DariCalendarService } from '../../../services/DariCalendar';
import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/Acc_ReportService';
import { UtilityService } from '../../../services/Acc_Utility.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { forkJoin } from "rxjs/observable/forkJoin";
import * as moment from 'jalali-moment';


@Component({
  selector: 'app-balance-sheet',
  templateUrl: './balance-sheet.component.html',
  styleUrls: ['./balance-sheet.component.css']
})
export class BalanceSheetComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  AssetList: any = [];
  LiabilityList: any = [];
  EquityList:any =[];
  IncomeList:any = [];
  ExpenseList:any = [];

  groupArrAssets:any;
  groupArrLiab:any;
  groupArrEquity:any;

  totalAssets:number;
  totalLiabilities:number;
  totalEquity:number;
  totalIncome:number;
  totalExpense:number;
  totalNetIncome:number;


  constructor(
    private ReportService: ReportService,
    private DariCalendar: DariCalendarService,
    private UtilityService: UtilityService,
    private global:Global,
    private dateConverter: DatePipe)
     {
      this.totalAssets = 0;
      this.totalLiabilities = 0;
      this.totalEquity = 0;
      this.totalIncome = 0;
      this.totalExpense = 0;
      }

  ngOnInit() {
    this.getLabels();
    this.getBranchId()
    this.getBalanceSheet();
  }

  isBranchId: number = -1;
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
    }
  }

  getBalanceSheet()
  {

    let Assets = this.ReportService.BalanceSheet('Asset', this.isBranchId);
    let Liabilities = this.ReportService.BalanceSheet('Liability', this.isBranchId);
    let Equities = this.ReportService.BalanceSheet('Equity', this.isBranchId);
    let Incomes = this.ReportService.BalanceSheet('Income', this.isBranchId);
    let Expenses = this.ReportService.BalanceSheet('Expense', this.isBranchId);

    forkJoin([Assets,Liabilities,Equities,Incomes,Expenses]).subscribe(
      result =>{
        this.AssetList = result[0];
        this.LiabilityList = result[1];
        this.EquityList = result[2];
        this.IncomeList = result[3];
        this.ExpenseList = result[4];
        
        // Assets
        for (var i = 0; i < this.AssetList.length; i++)
        {
          this.totalAssets += this.AssetList[i].balance;
        }
        this.groupArrAssets= this.AssetList.reduce((r,{gl_master_desc})=>{
          if(!r.some(o=>o.gl_master_desc==gl_master_desc)){
            r.push({gl_master_desc,groupItem:this.AssetList.filter(v=>v.gl_master_desc==gl_master_desc)});
        }
        return r;
        },[]);

        //Liabilities
        for (var i = 0; i < this.LiabilityList.length; i++)
        {
          this.totalLiabilities += this.LiabilityList[i].balance;
        }

        this.groupArrLiab = this.LiabilityList.reduce((r,{gl_master_desc})=>{
          if(!r.some(o=>o.gl_master_desc==gl_master_desc)){
            r.push({gl_master_desc,groupItem:this.LiabilityList.filter(v=>v.gl_master_desc==gl_master_desc)});
        }
        return r;
        },[]);

        // Equities
        for (var i = 0; i < this.EquityList.length; i++)
        {
          this.totalEquity += this.EquityList[i].balance;
        }

        this.groupArrEquity = this.EquityList.reduce((r,{gl_master_desc})=>{
          if(!r.some(o=>o.gl_master_desc==gl_master_desc)){
            r.push({gl_master_desc,groupItem:this.EquityList.filter(v=>v.gl_master_desc==gl_master_desc)});
        }
        return r;
        },[]);

        //Incomes
        for (var i = 0; i < this.IncomeList.length; i++)
        {
          this.totalIncome += this.IncomeList[i].balance;
        }

        //Expenses
        for (var i = 0; i < this.ExpenseList.length; i++)
        {
          this.totalExpense += this.ExpenseList[i].balance;
        }

        // Net Income
        this.totalNetIncome = this.totalIncome - this.totalExpense;

      }
    )
  }

  getLabels(){
    this.UtilityService.getLabels('balance-sheet',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              console.log(response);
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){
    this.labels['balance-sheet-Title'] = this.ArrLabels.find( (o:any) => o.key === 'balance-sheet-Title').value;
    this.labels['Liabilities'] = this.ArrLabels.find( (o:any) => o.key === 'Liabilities').value;
    this.labels['Assets'] = this.ArrLabels.find( (o:any) => o.key === 'Assets').value;
    this.labels['Liabilities-sum'] = this.ArrLabels.find( (o:any) => o.key === 'Liabilities-sum').value;
    this.labels['Assets-sum'] = this.ArrLabels.find( (o:any) => o.key === 'Assets-sum').value;
    this.labels['stakeholders-equity'] = this.ArrLabels.find( (o:any) => o.key === 'stakeholders-equity').value;
    this.labels['stakeholders-equity-sum'] = this.ArrLabels.find( (o:any) => o.key === 'stakeholders-equity-sum').value;
    this.labels['TotalIncome'] = this.ArrLabels.find( (o:any) => o.key === 'TotalIncome').value;
    this.labels['TotalExpense'] = this.ArrLabels.find( (o:any) => o.key === 'TotalExpense').value;
    this.labels['TotalNetIncome'] = this.ArrLabels.find( (o:any) => o.key === 'TotalNetIncome').value;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reports/balance-sheet/balance-sheet.component.ts